<template>
  <div>
    <!-- <el-dialog
      class="public-dialog"
      :visible.sync="dialogOpen"
      width="52%"
      :before-close="handleClose"
      :close-on-click-modal="false"
      :title="title"
      @close="createFormClosed"
    > -->
      <el-form
        ref="createFormRef"
        :rules="createFormRules"
        :model="form"
        label-width="135px"
      >
        <el-row>
          <el-col :span="24">
            <el-form-item label="活动名称" prop="campaignName">
              <el-input
              :disabled="flag == 3"
                v-model="form.campaignName"
                style="width: 50%"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="会员维护门店" prop="isAllShop">
              <el-radio-group :disabled="flag == 3" v-model="form.isAllShop">
                <el-radio :label="true">所有门店</el-radio>
                <el-radio :label="false">部分门店</el-radio>
                <el-button
                  :disabled="form.isAllShop != false"
                  @click="Selectstore"
                  >选择门店</el-button
                >
              </el-radio-group>
              <el-form-item :prop="isStoreSelectionMethod">
                <textarea
                  style="width: 50%"
                  rows="8"
                  readonly
                  v-model="form.listOfSomeStoreslStr"
                ></textarea>
              </el-form-item>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="营销类型" prop="compaignKind">
              <el-select :disabled="flag == 3" style="width: 50%" v-model="form.compaignKind"  @change="changeCompaignKind">
                <el-option label="会员注册活动" :value="3"></el-option>
                <el-option label="会员升级" :value="4"></el-option>
                <el-option label="会员降级" :value="5"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="form.compaignKind == 4 ||  form.compaignKind == 5">
          <el-col :span="24">
            <el-form-item
                label="会员等级"
                prop="custLvl"
                :rules="
              form.compaignKind == 4 ||  form.compaignKind == 5
                ? [
                    {
                      type: 'array',
                      required: true,
                      message: '请至少选择一个会员等级',
                      trigger: 'change',
                    },
                  ]
                : [{ required: false }]
            "
            >
              <el-checkbox
                  :disabled="flag == 3"
                  v-model="form.custLvl"
                  v-for="item in checkbooksData"
                  :key="item.levelID"
                  :value="item.levelID"
                  :label="item.levelID"
              >
                {{ item.levelName_cn }}
              </el-checkbox>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="form.compaignKind == 4 ||  form.compaignKind == 5">
          <el-form-item label="领用限制">
            <el-col :span="10">
              <el-radio-group :disabled="flag == 3" v-model="form.actLimit"  @change="radioChange">
                <el-radio :label="0">无限制</el-radio>
                <el-radio :label="3">每人限领用</el-radio>
              </el-radio-group>
            </el-col>
            <el-col :span="2" style="display: flex">
              <el-input
                  :disabled="flag == 3 ? true : form.actLimit != 3"
                  v-model="form.limitNum"
              ></el-input
              ><span>次</span>
            </el-col>
          </el-form-item>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="活动时间 从" prop="startDate">
              <el-date-picker
              :disabled="flag == 3"
                style="width: 50%"
                v-model="form.startDate"
                type="date"
                placeholder="开始日期"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="(含) 至" prop="endDate">
              <!-- <span>(含)&nbsp;&nbsp;至</span> -->
              <el-date-picker
              :disabled="flag == 3"
                style="width: 50%"
                v-model="form.endDate"
                type="date"
                placeholder="结束日期"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="活动内容" prop="presentedKind">
              <el-radio-group :disabled="flag == 3" v-model="form.presentedKind">
                <el-radio :label="0">礼券</el-radio>
                <el-radio :label="1">券包</el-radio>
                <el-radio :label="2">积分</el-radio>
                <el-radio :label="3">短信</el-radio>
                <el-radio :label="4">彩信</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="form.presentedKind == 0">
          <el-col :span="24">
            <el-form-item label="券库" :prop="couponsNameyz">
              <div class="xiaoguo">
                <el-input
                  readonly
                  v-model="form.couponsName"
                  style="width: 50%"
                  @click.native="Juankubtn"
                ></el-input>
                <el-button @click="weachTher" :disabled="flag == 3">选择</el-button>
                <span style="color: rgb(135, 232, 235)"
                  >说明：选择现金券，折扣券，异业券，礼品券</span
                >
              </div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="form.presentedKind == 1">
          <el-col :span="24">
            <el-form-item label="券包" :prop="coupPacketNameyz">
              <div class="xiaoguo1">
                <el-input
                  readonly
                  v-model="form.coupPacketName"
                  style="width: 50%"
                  @click.native="Juanbaobtn"
                ></el-input>
                <el-button @click="weachTherqb" :disabled="flag == 3">选择</el-button>
                <span style="color: rgb(135, 232, 235)"
                  >说明：选择券包，点击“券包”跳转到券包详情</span
                >
              </div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="form.presentedKind == 2">
          <el-col :span="24">
            <el-form-item label="赠送积分" :prop="Bonuspointsyz">
              <el-input
              :disabled="flag == 3"
                v-model="form.Bonuspoints"
                style="width: 50%"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="form.presentedKind == 3">
          <el-col :span="24">
            <el-form-item label="短信" :prop="smsBodyyz">
              <el-input
              :disabled="flag == 3"
                v-model="form.smsBody"
                type="textarea"
                :rows="5"
                style="width: 50%"
              ></el-input>
              <span style="color: rgb(135, 232, 235)"
                >说明：填写短信内容，有变量：
                姓名、活动名称、积分、会员等级等</span
              >
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="form.presentedKind == 4">
          <el-col :span="24">
            <el-form-item label="彩信ID" :prop="MMsIDyz">
              <el-input :disabled="flag == 3" v-model="form.MMsID" style="width: 50%"></el-input>
              <span style="color: rgb(135, 232, 235)">说明:彩信消息ID</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row
          v-if="
            form.presentedKind == 0 ||
            form.presentedKind == 1 ||
            form.presentedKind == 3 ||
            form.presentedKind == 4
          "
        >
          <el-col :span="24">
            <el-form-item label="抄送人员" prop="chaosong">
              <el-input
              :disabled="flag == 3"
                readonly
                v-model="form.chaosong"
                style="width: 50%"
              ></el-input>
              <el-button @click="CCpersonnel" :disabled="flag == 3">选择</el-button>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="发放方式">
              <el-radio-group
                  :disabled="flag == 3"
                  v-model="form.sendMode"
                  @change="sendModeRadioChange"
              >
                <el-radio :label="0">立即发送</el-radio>
                <el-radio :label="1">定时发送</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="24">
            <el-form-item style="width: 57%" label="发放间隔天数"
                          :rules="
              form.sendMode == 1
                ? [
                    {
                      required: true,
                       message: '请输入发放间隔天数',
                      trigger: 'blur',
                    },
                  ]
                : [{ required: false }]
            "
            >
              <el-input
                  oninput="value=value.replace(/[^0-9]/g,'')"
                  :disabled="
                flag == 3 ? true : form.sendMode == 1 ? false : true
              "
                  v-model="form.disIntervalDay"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="24">
            <el-form-item
                label="定时发送时间点"
                prop="issueTime"
                :rules="
              form.sendMode == 1
                ? [
                    {
                      required: true,
                      message: '请选择定时发送时间',
                      trigger: 'blur',
                    },
                  ]
                : [{ required: false }]
            "
            >
              <el-time-picker
                  value-format="HH:mm:ss"
                  style="width: 36%; margin-left: 10px"
                  v-model="form.issueTime"
                  placeholder="任意时间点"
                  :disabled="
                flag == 3 ? true : form.sendMode == 1 ? false : true
              "
              >
              </el-time-picker>
            </el-form-item>
          </el-col>
        </el-row>



      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button v-if="flag != 3" @click="Create">保存</el-button>
        <el-button @click="close">取消</el-button>
      </div>
    <!-- </el-dialog> -->
    <!-- 选择门店弹窗 -->
    <div class="outlet">
      <el-dialog append-to-body width="30%" :visible.sync="outletVisible" title="选择门店">
        <el-form size="mini" label-width="90px">
          <el-row
            :gutter="50"
            v-for="(item, index) in StoreSelectionList"
            :key="index"
          >
            <el-col :span="12" v-for="(myitem, myindex) in item" :key="myindex">
              <el-tree
                ref="tree"
                v-if="myitem != undefined"
                :data="[myitem]"
                show-checkbox
                node-key="ShopID"
                highlight-current
                default-expand-all
                :default-checked-keys="xuanzhong"
                :props="defaultProps"
              >
              </el-tree>
            </el-col>
          </el-row>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="ComButtomStore">确 定</el-button>
          <el-button @click="outletVisible = false">取 消</el-button>
        </div>
      </el-dialog>
    </div>
    <!-- 选择劵库弹窗 -->
    <div class="choice">
      <el-dialog
      append-to-body
        width="40%"
        title="选择券库"
        :visible.sync="innerVisible"
        :close-on-click-modal="false"
      >
        <el-form size="mini" label-width="120px">
          <el-row>
            <el-col :span="12">
              <el-form-item label="券名称">
                <el-input v-model="queryArr.couponsName"> </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="券类型">
                <div class="flex-between">
                  <el-select style="width: 100%" v-model="queryArr.couponsKind">
                    <el-option label="全部" value=""> </el-option>
                    <el-option label="现金券" value="0"> </el-option>
                    <el-option label="折扣券" value="1"> </el-option>
                    <el-option label="礼品券" value="2"> </el-option>
                    <el-option label="异业券" value="3"> </el-option>
                  </el-select>
                  <el-button
                    icon="el-icon-search"
                    style="margin-left: 3%"
                    @click="Seachbtn"
                    >查询</el-button
                  >
                </div>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="创建时间">
                <el-date-picker
                  v-model="queryArr.createTime"
                  type="date"
                  placeholder="选择时间"
                  value-format="yyyy-MM-dd"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="至">
                <el-date-picker
                  v-model="queryArr.updateTime"
                  type="date"
                  placeholder="选择时间"
                  value-format="yyyy-MM-dd"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div style="width: 100%; margin-top: 10px">
          <el-table
            height="300"
            class="table-style"
            border
            :row-class-name="tableRowClassName"
            :header-cell-style="{
              background: '#FCFBF2',
              color: '#6C6839',
              'text-align': 'center',
            }"
            :cell-style="{ 'text-align': 'center' }"
            ref="multipleTable"
            :data="queryList"
            tooltip-effect="dark"
            v-el-table-infinite-scroll="load"
            v-loading="loading"
            infinite-scroll-disabled="onLoading"
          >
            <el-table-column width="40">
              <template slot-scope="scope">
                <el-radio
                  v-model="radioId"
                  :label="scope.$index"
                  @change.native="handleRadioChange(scope.row)"
                  >&nbsp;
                </el-radio>
              </template>
            </el-table-column>
            <el-table-column prop="couponsName" label="券名称">
            </el-table-column>
            <el-table-column prop="innerCoupName" label="券后台名称">
            </el-table-column>
            <el-table-column prop="couponsKind" label="券类型">
              <template scope="scope">
                {{
                  scope.row.couponsKind === 0
                    ? " 现金券"
                    : "" || scope.row.couponsKind === 1
                    ? "折扣券"
                    : "" || scope.row.couponsKind === 2
                    ? "礼品券"
                    : "" || scope.row.couponsKind === 3
                    ? "异业券"
                    : ""
                }}
              </template>
            </el-table-column>
            <el-table-column prop="coupValue" label="券值"></el-table-column>
            <el-table-column prop="giftNo" label="礼品编号"></el-table-column> 
            <el-table-column prop="giftName" label="礼品名称"></el-table-column>
            <el-table-column prop="createUserName" label="创建人">
            </el-table-column>
            <el-table-column prop="createTime" label="创建时间">
              <template scope="scope">
                {{ scope.row.createTime | dateFormats }}
              </template>
            </el-table-column>
          </el-table>
          <el-alert
            v-if="isMore"
            title="没有更多啦!"
            type="warning"
            center
            show-icon
            :closable="false"
          >
          </el-alert>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="determine">确 定</el-button>
          <el-button @click="innerVisible = false">取 消</el-button>
        </div>
      </el-dialog>
    </div>
    <!-- 选择券包 -->
    <div class="choice">
      <el-dialog append-to-body width="35%" title="选择券包" :visible.sync="innerVisibleqb">
        <el-form size="mini" label-width="100px">
          <el-row>
            <el-col>
              <el-form-item label="券包名称">
                <el-input
                  style="width: 60%"
                  v-model="queryArrqb.coupPacketName"
                ></el-input>
                <el-button
                  icon="el-icon-search"
                  style="margin-left: 3%"
                  @click="Seachbtnerqb"
                  >查询</el-button
                >
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>

        <div style="width: 100%">
          <el-table
            size="mini"
            height="300"
            class="table-style"
            border
            :row-class-name="tableRowClassName"
            :header-cell-style="{
              background: '#FCFBF2',
              color: '#6C6839',
              'text-align': 'center',
            }"
            :cell-style="{ 'text-align': 'center' }"
            ref="multipleTable"
            :data="queryListqb"
            tooltip-effect="dark"
            v-el-table-infinite-scroll="loadqb"
            v-loading="loadingqb"
            infinite-scroll-disabled="onLoadingqb"
          >
            <el-table-column label width="35">
              <template slot-scope="scope">
                <el-radio
                  v-model="radioIdqb"
                  :label="scope.$index"
                  @change.native="handleRadioChangeqb(scope.row)"
                  >&nbsp;
                </el-radio>
              </template>
            </el-table-column>
            <el-table-column prop="coupPacketName" label="券名称">
            </el-table-column>
          </el-table>
          <el-alert
            v-if="isMoreqb"
            title="没有更多啦!"
            type="warning"
            center
            show-icon
            :closable="false"
          >
          </el-alert>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="Determineqb">确 定</el-button>
          <el-button @click="innerVisibleqb = false">取 消</el-button>
        </div>
      </el-dialog>
    </div>
    <!-- 选择会员 -->
    <div class="choice">
      <el-dialog
      append-to-body
        width="55%"
        title="选择会员"
        :visible.sync="innerVisiblery"
        :close-on-click-modal="false"
      >
        <el-form size="mini" label-width="200px">
          <el-form-item label="会员姓名\会员卡号\手机号">
            <div class="flex-between">
              <el-input style="width: 300px" v-model="queryArrry.search">
              </el-input>
              <el-button
                style="
                  width: 80px;
                  margin-left: 10px;
                  background-color: #f1f1f1;
                  color: #b6b388;
                "
                size="mini"
                icon="el-icon-search"
                @click="Seachbtnry"
                >查询</el-button
              >
            </div>
          </el-form-item>
        </el-form>
        <div style="width: 100%">
          <el-table
            size="mini"
            height="300"
            class="table-style"
            border
            :row-class-name="tableRowClassName"
            :header-cell-style="{
              background: '#FCFBF2',
              color: '#6C6839',
              'text-align': 'center',
            }"
            :cell-style="{ 'text-align': 'center' }"
            ref="multipleTable"
            :data="queryListry"
            tooltip-effect="dark"
            v-el-table-infinite-scroll="loadry"
            v-loading="loadingry"
            infinite-scroll-disabled="onLoadingry"
            @select="handleSelectionChange"
          >
            <el-table-column type="index" width="50"> </el-table-column>
            <el-table-column type="selection" label="选择" width="50">
            </el-table-column>
            <el-table-column prop="cardNo" label="会员卡号"> </el-table-column>
            <el-table-column prop="custName" label="会员姓名">
            </el-table-column>
            <el-table-column prop="mobile" label="手机号"> </el-table-column>
            <el-table-column prop="levelName" label="消费等级">
            </el-table-column>
            <el-table-column prop="regionName" label="所属区域">
            </el-table-column>
            <el-table-column prop="shopName" label="所属门店">
            </el-table-column>
            <el-table-column prop="serviceEmpName" label="维护品牌顾问">
            </el-table-column>
          </el-table>
          <el-alert
            v-if="isMorery"
            title="没有更多啦!"
            type="warning"
            center
            show-icon
            :closable="false"
          >
          </el-alert>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="Selectemployees">确 定</el-button>
          <el-button @click="innerVisiblery = false">取 消</el-button>
        </div>
      </el-dialog>
      <div>
        <el-dialog
          append-to-body
          width="80%"
          title="券库详情"
          :visible.sync="quankuShow"
          :close-on-click-modal="false"
        >
          <quanku ref="quanku"></quanku>
        </el-dialog>
        <el-dialog
          append-to-body
          width="80%"
          title="券包详情"
          :visible.sync="quanbaoShow"
          :close-on-click-modal="false"
        >
          <quanbao ref="quanbao"></quanbao>
        </el-dialog>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import {
  shopQueryRegionApi,
  couponsGroupApi,
  couppacketJuanApi,
  custselectCustList,
  marketingInsertApi,
  marketingEitApi,
} from "@/api/marketing";
import {dateTimes, getcpyNo} from "@/utils/auth";
import quanku from "/src/components/quanku.vue";
import quanbao from "/src/components/quanbao.vue";
import {queryLSelectApi} from "@/api/user";
export default {
  components: {
    quanku: quanku,
    quanbao:quanbao
  },
  data() {
    return {
      quanbaoShow:false,
      quankuShow: false,

      xuanzhong:[],
      title: "",
      dialogOpen: false,
      display: false,
      shoplist: "",
      ccMap: [],
      checkbooksData: [],
      form: {
        campaignName: "", // 活动名称
        isAllShop: true, //  维护门店
        compaignKind: "", // 营销类型
        startDate: "", // 活动开始日期
        endDate: "", // 活动结束日期
        presentedKind: 0, // 活动类容
        couponsName: "", // 券库名字
        couponsKind: "", // 券类型
        presentedObjIDqk: "",
        coupPacketName: "", // 券包名字
        presentedObjIDqb: "",
        Bonuspoints: "", // 赠送积分
        presentedObjID: "", //券库ID||券包ID||积分||彩信ID
        smsBody: "", // 短信消息
        MMsID: "", // 彩信ID
        chaosong: "", // 抄送人员
        ccMap: [], // 抄送人员数组
        // CC1: "",
        // CC2: "", //抄送人员123
        // CC3: "",
        listOfSomeStoresl: [], // 选择门店
        listOfSomeStoreslStr: "", // 选择门店
        campaignID: "",
        sendMode: 0,
        disIntervalDay: 0,
        issueTime: "",
        saleLimieFlag: 0,
        custLvl: [],
        actLimit: 0,
        limitNum: "",
      },
      flag: "",
      // 选择门店
      outletVisible: false,
      StoredataArray: [],
      StoreSelectLength: 0,
      // 选择门店数据
      StoreSelectionList: [],
      defaultProps: {
        children: "chlidren",
        label: "lable",
      },
      // 券库
      innerVisible: false,
      // 券库券分类ID
      couponsKind: "",
      // 选择券库loading
      loading: false,
      //选择劵库弹窗数据
      queryList: [],
      // 内层弹窗请求数据
      queryArr: {
        state:0,
        couponsName: "", //卷名称
        couponsKind: "", //卷类型
        createTime: "",
        updateTime: "",
        pageSize: 50,
        pageNo: 1,
        pages: 0,
      },
      // 选择券库radio数据
      radioId: "",
      templatei: "",
      // 券包
      innerVisibleqb: false,
      // 选择券包loadingqb
      loadingqb: false,
      // 选择券包弹窗数据
      queryListqb: [],
      // 内层弹窗请求数据
      queryArrqb: {
        state:0,
        pageSize: 50,
        pageNo: 1,
        pages: 0,
        coupPacketName: "",
      },
      radioIdqb: "",
      templateiqb: "",
      // 选择人员参数
      queryArrry: {
        search: "",
        pageNo: 1,
        pageSize: 50,
        pages: 0,
      },
      // 选择抄送人员数据
      queryListry: [],
      // 选择人员
      innerVisiblery: false,
      // 选择人员loadingry
      loadingry: false,
      obtainData: null,
      checkNumber: 0, // 设置可选中的数量
      sendMode: 0, //
      ryarr: [],
      // 表单验证
      createFormRules: {
        campaignName: [
          { required: true, message: "请输入活动名称", trigger: "blur" },
        ],
        startDate: [
          { required: true, message: "请选择活动开始时间", trigger: "blur" },
        ],
        endDate: [
          { required: true, message: "请选择活动结束时间", trigger: "blur" },
        ],
        isAllShop: [
          { required: true, message: "请选择会员维护门店", trigger: "blur" },
        ],
        listOfSomeStoreslStr: [
          {
            required: true,
            message: "请选择会员维护部分门店",
            trigger: "blur",
          },
        ],
        compaignKind: [
          { required: true, message: "请选择营销类型", trigger: "change"  },
        ],
        presentedKind: [
          { required: true, message: "请选择活动内容", trigger: "blur" },
        ],
        couponsName:[
          { required: true, message: "请选择券库", trigger: "blur" },
        ],
        coupPacketName:[
          { required: true, message: "请选择券包", trigger: "blur" },
        ],
        Bonuspoints:[
          { required: true, message: "请输入积分", trigger: "blur" },
        ],
        smsBody:[
          { required: true, message: "请输入短信", trigger: "blur" },
        ],
        MMsID:[
          { required: true, message: "请输入彩信ID", trigger: "blur" },
        ],
      },

    };
  },
  computed: {
    // 选择券库弹窗
    isMore() {
      //当起始页数等于总页数时停止加载
      return this.queryArr.pageNo >= this.queryArr.pages;
    },
    onLoading() {
      return this.loading || this.isMore;
    },
    // 选择券包弹窗
    isMoreqb() {
      //当起始页数等于总页数时停止加载
      return this.queryArrqb.pageNo >= this.queryArrqb.pages;
    },
    onLoadingqb() {
      return this.loadingqb || this.isMoreqb;
    },
    // 选择人员弹窗
    isMorery() {
      //当起始页数等于总页数时停止加载
      return this.queryArrry.pageNo >= this.queryArrry.pages;
    },
    onLoadingry() {
      return this.loadingry || this.isMorery;
    },
    ...mapState(["confirmButtonText", "cancelButtonText"]),
    isStoreSelectionMethod() {
      if (this.form.isAllShop == false) {
        return "listOfSomeStoreslStr";
      } else {
        return "Str";
      }
    },
    couponsNameyz(){
      if(this.form.presentedKind == 0){
        return "couponsName"
      } else {
        return "Str"
      }
    },
    coupPacketNameyz(){
      if(this.form.presentedKind == 1){
        return "coupPacketName"
      } else {
        return "Str"
      }
    },
    Bonuspointsyz(){
      if(this.form.presentedKind == 2){
        return "Bonuspoints"
      } else {
        return "Str"
      }
    },
    smsBodyyz(){
      if(this.form.presentedKind == 3){
        return "smsBody"
      } else {
        return "Str"
      }
    },
    MMsIDyz(){
      if(this.form.presentedKind == 4){
        return "MMsID"
      } else {
        return "Str"
      }
    },
  },
  created() {
    this.ShopqueryRegionList();
    queryLSelectApi({ cpyNO: getcpyNo() }).then((res) => {
      this.checkbooksData = res.data;
    });
  },
  methods: {
      close(){
          this.$emit("close")
      },
    //监听营销类型选择
    changeCompaignKind(e) {
      if (e == 3) {
        this.form.custLvl = [];
        this.form.actLimit = 0;
        this.form.limitNum = 0;
      }
    },
    // 判断如果是单行就变黄色双行是白色
    tableRowClassName({ rowIndex }) {
      if (rowIndex % 2 === 1) {
        return "warning-row";
      }
      return "";
    },
    // 监听弹窗关闭事件
    createFormClosed() {
      this.$refs.createFormRef.resetFields();
      this.flag = "";
      this.form.coupPacketName = "",
      this.form.Bonuspoints = "",
      this.form.smsBody = "",
      this.form.MMsID = "",
      this.form.couponsName = "";
    },
    // 选择门店弹窗事件
    Selectstore() {
      this.outletVisible = true;
    },
    // 获取区域门店
    ShopqueryRegionList() {
      shopQueryRegionApi().then((res) => {
        let arr1 = [],
          arr2 = [];
        if (res.success) {
          res.data.forEach((item) => {
            if (item.chlidren.length > 0) this.StoredataArray.push(item);
          });
          this.StoredataArray.forEach((item, index) => {
            item.chlidren.forEach((item) => {
              item.ShopID = item.id;
            });
            this.StoreSelectLength += 1;
            if (index % 2 == 0) {
              arr1.push(item);
            } else {
              arr2.push(item);
            }
          });
          this.StoreSelectionList = arr1.map((key, value) => [
            key,
            arr2[value],
          ]);
        } else {
          this.$message.error(res.message);
        }
      });
    },
    // 选择门店
    ComButtomStore() {
      //获取已选择的门店数据
      this.form.listOfSomeStoresl = [];
      this.form.listOfSomeStoreslStr = "";
      for (let index = 0; index < this.StoreSelectLength; index++) {
        let item = this.$refs.tree[index].getCheckedNodes();
        if (item.length == this.StoredataArray[index].chlidren.length + 1) {
          this.form.listOfSomeStoresl.push(
            ...this.StoredataArray[index].chlidren
          );
        } else {
          this.form.listOfSomeStoresl.push(...item);
        }
      }
      this.form.listOfSomeStoresl.forEach((item) => {
        this.form.listOfSomeStoreslStr += `${item.lable}\n`;
      });
      // this.form.listOfSomeStoreslStr = this.form.listOfSomeStoreslStr.substring(
      //   0,
      //   this.form.listOfSomeStoreslStr.length - 2
      // );
      this.xuanzhong = [];
      for (let i = 0; i < this.form.listOfSomeStoresl.length; i++) {
        this.xuanzhong.push(this.form.listOfSomeStoresl[i].id);
      }
      this.outletVisible = false;
    },
    //选择劵库数据请求
    async Securitieslibrary() {
      await couponsGroupApi(this.queryArr).then((res) => {
        this.queryList = res.data.list;
        this.queryArr.pages = res.data.pages;
        this.loading = false;
      });
    },
    load() {
      this.loading = true;
      setTimeout(() => {
        this.queryArr.pageSize += 50; //页数据+50
        this.Securitieslibrary(); // 重新获取数据，此时页数据+50
      });
    },
    //点击选中劵库获取数据
    weachTher() {
      this.Securitieslibrary();
      this.innerVisible = true;
    },
    //查询
    Seachbtn() {
      this.Securitieslibrary();
    },
    // 选择券库弹窗radio选中数据
    handleRadioChange(val) {
      console.log(val);
      this.templatei = val;
    },
    // 选择券库确定事件
    determine() {
      this.form.couponsKind = this.templatei.couponsKind;
      this.form.couponsName = this.templatei.couponsName;
      this.form.presentedObjIDqk = this.templatei.couponsGrpID;
      this.radioId = "";
      this.innerVisible = false;
    },
    //点击选中劵库获取数据
    weachTherqb() {
      this.Securitieslibraryqb();
      this.innerVisibleqb = true;
    },
    // 选择券包数据
    async Securitieslibraryqb() {
      await couppacketJuanApi(this.queryArrqb).then((res) => {
        this.queryListqb = res.data.list;
        this.queryArrqb.pages = res.data.pages;
        this.loadingqb = false;
      });
    },
    loadqb() {
      this.loading = true;
      setTimeout(() => {
        this.queryArrqb.pageSize += 50; //页数据+50
        this.Securitieslibraryqb(); // 重新获取数据，此时页数据+50
      });
    },
    // 查询
    Seachbtnerqb() {
      this.Securitieslibraryqb();
    },
    // 选择券包弹窗radio选中数据
    handleRadioChangeqb(val) {
      console.log(val);
      this.templateiqb = val;
    },
    // 选择券包确定事件
    Determineqb() {
      this.form.coupPacketName = this.templateiqb.coupPacketName;
      this.form.presentedObjIDqb = this.templateiqb.coupPacketID;
      this.radioId = "";
      this.innerVisibleqb = false;
    },
    // 抄送人员选择按钮事件
    CCpersonnel() {
      this.sysempselectEmpList();
      this.innerVisiblery = true;
    },
    // 选择人员数据请求
    async sysempselectEmpList() {
      await custselectCustList(this.queryArrry).then((res) => {
        this.queryListry = res.data.list;
        this.queryArrry.pages = res.data.pages;
        this.loadingry = false;
      });
    },
    loadry() {
      console.log("触底啦");
      this.loadingry = true;
      setTimeout(() => {
        this.queryArrry.pageSize += 50; //页数据+50
        this.sysempselectEmpList(); // 重新获取数据，此时页数据+50
      });
    },
    // 选择人员查询按钮事件
    Seachbtnry() {
      this.sysempselectEmpList();
    },
    handleSelectionChange(selection, index) {
      this.checkNumber = selection.length;
      if (this.checkNumber >= 4) {
        this.$message({
          message: "只能选中3个!",
          type: "warning",
        });
        this.$refs.multipleTable.toggleRowSelection(index, false);
        selection.length = 3;
      }
      this.arrry = selection;
      console.log("arr", this.arrry);
    },
    // 选择员工确定事件
    Selectemployees() {
      this.form.chaosong = "";
      this.form.ccMap = [];
      if (this.arrry !== undefined) {
        console.log("执行了");
        console.log(this.arrry);
        this.arrry.forEach((item) => {
          this.form.chaosong += item.custName + ",";
          this.form.ccMap.push(item.custID);

        });
        console.log("CCID", this.form.ccMap);
        this.form.chaosong = this.form.chaosong.substring(
          0,
          this.form.chaosong.length - 1
        );
      }
      this.arrry = [];
      this.innerVisiblery = false;
    },
    // 创建确定事件
    Create() {
      
      this.$refs.createFormRef.validate((valid) => {
        if (!valid) return true;
        this.Createqq();
      });
    },
    
    // 创建请求事件
    Createqq() {
      let shopID = [];
      if (this.form.listOfSomeStoresl.length > 0) {
        // 处理选择部分门店
        this.form.listOfSomeStoresl.forEach((item) => {
          shopID.push(item.ShopID);
        });
      }
      let custLvlList=[];
      let actLimitStr="";
      if(this.form.compaignKind==4||this.form.compaignKind==5){
        custLvlList=this.form.custLvl.toString();
        actLimitStr=this.form.actLimit;
      }

      let Membershiplevel = {
        campaignName: this.form.campaignName, // 活动名称
        isAllShop: this.form.isAllShop, // 维护门店
        shopID: this.form.isAllShop == false ? shopID.join(",") : undefined,
        compaignKind: this.form.compaignKind, // 营销类型
        startDate:
          this.form.startDate != ""
            ? dateTimes(this.form.startDate)
            : undefined, // 活动开始日期
        endDate:
          this.form.endDate != "" ? dateTimes(this.form.endDate) : undefined, // 活动结束日期
        presentedKind: this.form.presentedKind, // 活动类容
        presentedObjID:
          this.form.presentedKind == 0
            ? this.form.presentedObjIDqk
            : this.form.presentedKind == 1
            ? this.form.presentedObjIDqb
            : this.form.presentedKind == 2
            ? this.form.Bonuspoints
            : this.form.presentedKind == 4
            ? this.form.MMsID
            : "", // 券库ID||券包ID||积分||菜信ID
        smsBody: this.form.presentedKind == 3 ? this.form.smsBody : "", // 短信消息
        custLvl: custLvlList, //会员等级
        sendMode: this.form.sendMode,
        actLimit: actLimitStr,
        limitNum: this.form.actLimit == 3 ? this.form.limitNum : "",
        saleLimieFlag: 0, //定时发放时销售单限制
        disIntervalDay:
            this.form.sendMode == 1
                ? this.form.disIntervalDay
                : null,
        issueTime:
            this.form.sendMode == 1 ? this.form.issueTime : null, //执行时间
        CC1:
          this.form.presentedKind == 2
            ? undefined
            : this.form.ccMap.length >= 1
            ? this.form.ccMap[0]
            : undefined,
        CC2:
          this.form.presentedKind == 2
            ? undefined
            : this.form.ccMap.length >= 2
            ? this.form.ccMap[1]
            : undefined,
        CC3:
          this.form.presentedKind == 2
            ? undefined
            : this.form.ccMap.length >= 3
            ? this.form.ccMap[2]
            : undefined,
      };

      if (this.flag == 2) {
        Membershiplevel.campaignID = this.form.campaignID;
        Membershiplevel.state = this.form.state;
        marketingEitApi(Membershiplevel).then((res) => {
          if (res.success !== true) {
            this.$message.error("修改活动失败!");
            return;
          } else {
            this.$message.success("修改活动成功!");
            this.$emit("success");
          }
        });
      } else {
        marketingInsertApi(Membershiplevel).then((res) => {
          if (res.success !== true) {
            this.$message.error("创建活动失败!");
            return;
          }
          {
            this.$message.success("创建活动成功!");
            this.$emit("success");
          }
        });
      }
    },
    // 券库点击跳转
    Juankubtn() {
      if(this.form.presentedObjIDqk) {
        this.quankuShow = true;
        this.$nextTick(() => {
          this.$refs.quanku.RcouponsGroupDetail(this.form.presentedObjIDqk);
        })
      } else {
        console.log("券库")
        return;
      }

    },
    // 券包点击跳转查看详情
    Juanbaobtn() {
      if(this.form.presentedObjIDqb){
        this.quanbaoShow = true;
        this.$nextTick(() => {
          this.$refs.quanbao.Rcouppacketview(this.form.presentedObjIDqb)
        })
      }else{
        console.log("123123")
      }
      // if (this.form.coupPacketName !== "") {
      //   this.$router.push({
      //     path: "/VoucherSee",
      //     query: {
      //       mobile: this.form.presentedObjIDqb,
      //     },
      //   });
      // }
    },
    // 新增处理数据
    parentHandleclick() {
        this.form = {
          campaignName: "", // 活动名称
          isAllShop: true, //  维护门店
          compaignKind: "", // 营销类型
          startDate: "", // 活动开始日期
          endDate: "", // 活动结束日期
          presentedKind: 0, // 活动类容
          couponsName: "", // 券库名字
          couponsKind: "", // 券类型
          presentedObjIDqk: "",
          coupPacketName: "", // 券包名字
          presentedObjIDqb: "",
          Bonuspoints: "", // 赠送积分
          presentedObjID: "", //券库ID||券包ID||积分||彩信ID
          smsBody: "", // 短信消息
          MMsID: "", // 彩信ID
          chaosong: "", // 抄送人员
          ccMap: [], // 抄送人员数组
          // CC1: "",
          // CC2: "", //抄送人员123
          // CC3: "",
          listOfSomeStoresl: [], // 选择门店
          listOfSomeStoreslStr: "", // 选择门店
          campaignID: "",
          sendMode: 0,
          disIntervalDay: 0,
          issueTime: "",
          saleLimieFlag: 0,
          custLvl: [],
          actLimit: 0,
          limitNum: "",
        };
        return;
    },
    // 修改回显处理数据
    chulishuju(res) {
      if (res.flag == 2 || res.flag == 3) {
        this.flag = res.flag;
        this.form.campaignID = res.data.campaignID;
        this.form.state = res.data.state;
      }
      this.form = res.data;
      this.shoplist = res.shopList;
      this.ccMap = res.data.ccMap;
      // 客户等级
      let array = [];
      for (let i = 0; i < res.custLvl.length; i++) {
        array.push(res.custLvl[i].LevelID);
      }
      this.$set(this.form, "custLvl", array);
      // 门店处理数据
      if (this.shoplist !== null) {
        this.form.listOfSomeStoresl = [];
        this.form.listOfSomeStoreslStr = "";
        for (var i in this.shoplist) {
          this.form.listOfSomeStoresl.push(this.shoplist[i]);
        }
        this.form.listOfSomeStoresl.forEach((item) => {
          this.form.listOfSomeStoreslStr += `${item.ShopName}\n`;
        });
        // this.form.listOfSomeStoreslStr =
        //   this.form.listOfSomeStoreslStr.substring(
        //     0,
        //     this.form.listOfSomeStoreslStr.length - 2
        //   );
      }
      // 门店默认选中数据
      this.xuanzhong = [];
      if(this.shoplist !== null){
        this.shoplist.forEach((item) =>{
          console.log("2123",item)
          this.xuanzhong.push(item.ShopID)
          console.log(this.xuanzhong)
        })
      }
      // 抄送人员处理数据
      if (res.data.cc1Name !== "" || res.data.cc1 !== null) {
        this.form.chaosong = "";
        this.form.ccMap = [];
        this.ccMap.forEach((item) => {
          this.form.chaosong +=
            item.ccName != "" ? item.ccName + "," : item.ccName;
          this.form.ccMap.push(item.cc);
        });
        console.log("回来的ID", this.form.ccMap);
        this.form.chaosong = this.form.chaosong.substring(
          0,
          this.form.chaosong.length - 1
        );
        console.log("回来的name", this.form.chaosong);
      }else{
          this.form.ccMap = []
      }
      // 抄送人员处理数据
      if (this.form.presentedKind == 0) {
        this.$set(this.form, "presentedObjIDqk", res.data.presentedObjID);
      } else if (this.form.presentedKind == 1) {
        this.$set(this.form, "presentedObjIDqb", res.data.presentedObjID);
      } else if (this.form.presentedKind == 2) {
        this.$set(this.form, "Bonuspoints", res.data.presentedObjID);
      } else if (this.form.presentedKind == 4) {
        this.$set(this.form, "MMsID", res.data.presentedObjID);
      }
    },
    sendModeRadioChange(index) {
      console.log(index)
      if (index == 0) {
        this.form.disIntervalDay = '';
        this.form.issueTime = '';
      } else {
        this.form.disIntervalDay = 1;
      }
    },
    radioChange(index) {
      if (index === 0) {
        this.form.limitNum = "";
      } else {
        this.form.limitNum = 1;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.dialog-footer {
  height: 40px;
  display: flex;
  justify-content: space-around;
}
/deep/.el-dialog__header {
  padding: 1.25rem 1.25rem 0.625rem;
  background-color: #d1cda5;
}
.el-dialog__header {
  background-color: #f3f1dd;
}
.el-dialog__title {
  font-size: 14px;
  font-weight: 700;
  color: #6c6937;
}
/deep/.el-dialog__footer {
  height: 60px;
  text-align: center;
  background-color: #f2f2f2;
}
.el-button:hover {
  background-color: #b5b386;
  color: #f2f2f2;
}
// 选择门店弹框样式
.outlet {
  .el-dialog__header {
    background-color: #f3f1dd;
  }
  .el-dialog__title {
    font-size: 14px;
    font-weight: 700;
    color: #6c6937;
  }
  .el-dialog__body {
    padding: 20px 10px 20px 10px;
  }
  .el-dialog__footer {
    height: 60px;
    text-align: center;
    background-color: #f2f2f2;
  }
  .el-button:hover {
    background-color: #b5b386;
    color: #f2f2f2;
  }
}
/deep/.xiaoguo .el-input .el-input__inner {
  color: blue;
  text-decoration: underline;
}
/deep/.xiaoguo1 .el-input .el-input__inner {
  color: blue;
  text-decoration: underline;
}
.el-radio__original {
  display: none !important; /* 隐藏原生 radio 输入，但仍然允许交互 */
}
</style>